import type { TimelineItem } from "../types/content";

export const education: TimelineItem[] = [
  {
    title: "MSc Artificial Intelligence and Machine Learning",
    organization: "Technische Universität Darmstadt",
    location: "Darmstadt, Germany",
    dates: "October 2024 — Present",
    badge: "In progress",
    description:
      "Advanced study across artificial intelligence, perception, intelligent systems and research methodology.",
    areas: [
      "Artificial Intelligence",
      "Machine Learning",
      "Computer Vision",
      "Robotics",
      "Scalable data management",
      "Research methodology",
    ],
  },
  {
    title: "BSc (Hons) Computer Science — Systems Engineering",
    organization: "Middlesex University",
    location: "London, United Kingdom",
    dates: "September 2021 — May 2024",
    badge: "First Class",
    description:
      "Systems-focused computer-science degree with practical work in software, robotics, embedded systems and experimental research.",
    areas: [
      "Systems engineering",
      "Software development",
      "Robotics",
      "Embedded systems",
      "Computer vision",
      "Autonomous navigation",
    ],
  },
];
